var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadHealthScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E09D19",
    fillOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 20.5714,
    fill: "#E09D19",
    fillOpacity: 0.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 16.4571,
    fill: "#E09D19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4346 21.0691C20.446 17.51 21.4517 15.7304 22.8318 15.2723C23.5909 15.0203 24.4088 15.0203 25.1679 15.2723C26.548 15.7304 27.5537 17.51 29.5651 21.0691C31.5765 24.6282 32.5822 26.4078 32.2805 27.8578C32.1145 28.6555 31.7056 29.379 31.1123 29.9248C30.034 30.9167 28.0227 30.9167 23.9998 30.9167C19.977 30.9167 17.9656 30.9167 16.8873 29.9248C16.2941 29.379 15.8852 28.6555 15.7192 27.8578C15.4175 26.4078 16.4232 24.6282 18.4346 21.0691Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9932 26.3333H23.9999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.8333V20.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadHealthScore);
export default __webpack_public_path__ + "static/media/bad-health-score.3e67d9f0a293e051b0dbc3588e098772.svg";
export { ForwardRef as ReactComponent };